import CTL_LoadingIcon from "./CTL_LoadingIcon";

export default function CTL_LoadingScreen() {

  return <>
    <div className='w-screen h-screen flex flex-col items-center justify-center'>
      <div className='flex flex-col items-center gap-5'>
        <CTL_LoadingIcon className="w-8 fill-black/35" />
        <div className='flex flex-col items-center'>
          <div>페이지를 로딩하는 중입니다.</div>
          <div>잠시만 기다려 주세요.</div>
          </div>
      </div>
    </div>
  </>
}